export default "__VITE_ASSET__39856739__"